// This file is generated, do not edit!
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import { FreeDayCreate, type FreeDayCreatedListe } from "../../api";
import { useGetApi } from "../client";
import { useCallback } from "react";

export function useAddMandantFreedays(): (
  mandantId: string,
  requestBody: Array<FreeDayCreate>
) => Promise<FreeDayCreatedListe> {
  const getAPI = useGetApi();
  return useCallback(
    async (mandantId, requestBody) =>
      (await getAPI()).mandanten.addMandantFreedays({ mandantId, requestBody }),
    [getAPI]
  );
}
